module.exports = __webpack_public_path__ + "static/media/angryGnome.f88bc043.svg";